import { RebatePayoutStatusCode } from "@/gql/graphql";
import type { RebateModalMode } from "../components/HandleRebateFormModal";

/**
 * Paying out everything is Paid, releasing everything is Failed and any
 * split is Negotiated. With nothing reserved both pay and release are zero,
 * so the amounts cannot tell paying from releasing and the mode decides.
 */
export const resolveStatusCodeForPayout = (
  mode: RebateModalMode,
  amountToPay: number,
  amountToRelease: number,
  reserved: number
): RebatePayoutStatusCode => {
  if (reserved === 0) {
    return mode === "RELEASE"
      ? RebatePayoutStatusCode.Failed
      : RebatePayoutStatusCode.Paid;
  }
  if (amountToPay === 0 && amountToRelease === reserved) {
    return RebatePayoutStatusCode.Failed;
  }
  if (amountToPay === reserved && amountToRelease === 0) {
    return RebatePayoutStatusCode.Paid;
  }
  return RebatePayoutStatusCode.Negotiated;
};
